import { Box, Grid2 as Grid, Typography, useTheme } from '@mui/material';
import DOMPurify from 'dompurify';
import * as React from 'react';
import LanguageSelector from './LanguageSelector';

import { LANGUAGE_MAP } from '../utils';

// Define allowed tags and attributes for sanitization
const SANITIZE_CONFIG = {
    USE_PROFILES: { html: true },
    ALLOWED_TAGS: ['p', 'br', 'b', 'strong', 'i', 'em', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ul', 'ol', 'li', 'div'],
    ALLOWED_ATTR: []
};

export const WaiverText = ({ waiver, lang, onLanguageChange }) => {
    const theme = useTheme();
    const hasMultipleLangs = Object.keys(waiver.text.values).length > 1;
    const langList = hasMultipleLangs ? Object.keys(waiver.text.values).map(x => ({ id: x, label: LANGUAGE_MAP[x].name })) : [];
    const effectiveLang = !!waiver.text.values[lang] ? lang : Object.keys(waiver.text.values)[0];
    const sanitizedText = DOMPurify.sanitize(waiver.text.values[effectiveLang] || '', SANITIZE_CONFIG);

    const onSwitchLang = (lang) => {
        onLanguageChange(lang);
    }

    return (
        <Grid container spacing={1} direction="column">
            <Grid container direction="row" justifyContent="space-between" alignItems="flex-start" sx={{ flexWrap: 'nowrap' }}>
                <Typography variant="h6" sx={{ fontWeight: 'bold', alignSelf: 'flex-start' }}>{waiver.name}</Typography>
                {hasMultipleLangs && (
                    <LanguageSelector langList={langList} effectiveLang={effectiveLang} onSwitchLang={onSwitchLang} />
                )}
            </Grid>
            
            <Grid size={12}>
                <Box sx={{ maxHeight: 300, overflowY: 'scroll', backgroundColor: 'white', padding: theme.spacing(2), paddingLeft: 0 }}>
                    <Typography
                        component="div"
                        variant="body1"
                        sx={{
                            textAlign: "left",
                            width: '100%',
                        }}
                        dangerouslySetInnerHTML={{ __html: sanitizedText }}
                    />
                </Box>
            </Grid>
        </Grid>
    );
}

export default WaiverText;
